module.exports = __webpack_public_path__ + "static/media/icon-tooltip.a286a679.svg";